import { parseSeoMetaField } from './parseSeoMeta'
import {
  APP_DISPLAY_NAME,
  PWA_META_DEFAULTS,
  SEO_DESCRIPTION_DEFAULTS,
  SEO_KEYWORDS_DEFAULTS,
} from './siteHeadDefaults'

/**
 * @param {import('vuex').Store} store
 * @param {{ title?: string, titleTemplate?: string, description?: string, meta?: string, descriptionVmid?: string, appleMobileWebAppTitle?: string, applicationName?: string, msapplicationTileColor?: string, themeColor?: string }} defaults
 */
export function metaFromSeoOrDefaults(store, defaults = {}) {
  const seo = store.state.seoPage
  const meta = []

  const rawMeta = seo && seo.meta != null ? String(seo.meta).trim() : ''
  const parsed = rawMeta ? parseSeoMetaField(rawMeta) : { description: '', isJson: false }

  const description =
    (parsed.isJson
      ? parsed.description || defaults.description || ''
      : rawMeta || defaults.description || '') || SEO_DESCRIPTION_DEFAULTS

  meta.push({
    vmid: defaults.descriptionVmid || 'description',
    name: 'description',
    content: description,
  })

  const keywords =
    (seo && seo.request && String(seo.request).trim()) ||
    (defaults.meta && String(defaults.meta).trim()) ||
    SEO_KEYWORDS_DEFAULTS
  if (String(keywords).trim()) {
    meta.push({ vmid: 'keywords', name: 'keywords', content: keywords })
  }

  const pwa = {
    appleMobileWebAppTitle:
      parsed.appleMobileWebAppTitle ||
      defaults.appleMobileWebAppTitle ||
      PWA_META_DEFAULTS.appleMobileWebAppTitle,
    applicationName:
      parsed.applicationName || defaults.applicationName || PWA_META_DEFAULTS.applicationName,
    msapplicationTileColor:
      parsed.msapplicationTileColor ||
      defaults.msapplicationTileColor ||
      PWA_META_DEFAULTS.msapplicationTileColor,
    themeColor:
      parsed.themeColor || defaults.themeColor || PWA_META_DEFAULTS.themeColor,
  }

  meta.push(
    { vmid: 'apple-mobile-web-app-title', name: 'apple-mobile-web-app-title', content: pwa.appleMobileWebAppTitle },
    { vmid: 'application-name', name: 'application-name', content: pwa.applicationName },
    { vmid: 'msapplication-TileColor', name: 'msapplication-TileColor', content: pwa.msapplicationTileColor },
    { vmid: 'theme-color', name: 'theme-color', content: pwa.themeColor }
  )

  const hasSeoTitle = seo && seo.title && String(seo.title).trim() !== ''

  if (hasSeoTitle) {
    return {
      title: seo.title,
      titleTemplate: '%s',
      meta,
    }
  }

  return {
    title: defaults.title || APP_DISPLAY_NAME,
    titleTemplate: defaults.titleTemplate || `%s - ${APP_DISPLAY_NAME}`,
    meta,
  }
}
